import firebase from 'firebase'

var firebaseConfig = {
  apiKey: 'AIzaSyC2Grf_nUEzFHnA5vHgWgOuOcLYQo9woJI',
  authDomain: 'elswer-key.firebaseapp.com',
  databaseURL: 'https://elswer-key.firebaseio.com',
  projectId: 'elswer-key',
  storageBucket: 'elswer-key.appspot.com',
  messagingSenderId: '18731321311',
  appId: '1:18731321311:web:5612be3e0b4005ab'
}
firebase.initializeApp(firebaseConfig)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export default firebase
